import { listingMeublesImageNomDescriptionMock } from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = (productType: string) => [listingMeublesImageNomDescriptionMock(productType)];

export const meublesImageNomDescriptionMock = (productType: string): SlugPage => ({
  ...pageBase({
    title: productType,
    type: 'undefined',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks: blocks(productType),
});
